// Structured content mirrored from gcanrx.com pages (already Trafalgar-branded upstream).
// Regulatory / SEC references are preserved verbatim.

export const COMPANY = {
  name: "Trafalgar International, Inc.",
  formerName: "Greater Cannabis Company, Inc.",
  ticker: "GCAN",
  market: "OTCQB",
  cik: "0001695473",
  fiscalYearEnd: "December 31",
  parent: "Empresas Trafalgar",
  rebrandDate: "July 29, 2026",
  irEmail: "ernesto.gomez@trafalgar.mx",
  address: {
    line1: "200 S Biscayne Blvd.",
    line2: "Floor 20",
    city: "Miami",
    state: "FL",
    postalCode: "33131",
    country: "United States",
    formatted: "200 S Biscayne Blvd., Floor 20, Miami, FL 33131",
  },
};

export const HOME = {
  eyebrow: "Entrepreneurial Growth Platform",
  headline: "Building businesses. Advancing technology. Creating long-term value.",
  headlineAccent: "long-term value.",
  intro:
    "Trafalgar International, Inc. is an entrepreneurial public company focused on strategic acquisitions, disciplined capital allocation, operational execution, and technology development. Building upon its existing biotechnology intellectual property and development assets, the Company is pursuing a broader strategy designed to expand and diversify its business.",
  approachEyebrow: "Our Approach",
  approachTitle: "A broader platform for strategic growth",
  approachIntro:
    "Our strategy combines entrepreneurial leadership, disciplined transaction evaluation, active operating involvement, and the thoughtful development of proprietary technologies.",
  pillars: [
    {
      num: "01",
      title: "Strategic Acquisitions",
      body:
        "We seek businesses, technologies, and assets with strong management, defensible market positions, scalable economics, and a clear path to long-term enterprise value.",
    },
    {
      num: "02",
      title: "Operational Development",
      body:
        "Trafalgar International, Inc. intends to work actively with management teams and strategic partners to strengthen operations, improve execution, accelerate commercialization, and build enduring businesses.",
    },
    {
      num: "03",
      title: "Technology & Intellectual Property",
      body:
        "The Company continues to preserve and evaluate its existing biotechnology assets while considering additional proprietary technologies, licensing opportunities, and strategic collaborations.",
    },
  ],
  opportunities: [
    "Strategic acquisitions and business combinations",
    "Operating partnerships and joint ventures",
    "Technology licensing and commercialization",
    "Special situations and underdeveloped assets",
    "Long-term, disciplined capital allocation",
  ],
  cards: [
    {
      key: "investors",
      title: "Investor Relations",
      body: "Market information, corporate profile and management overview.",
      to: "/investors",
    },
    {
      key: "sec",
      title: "SEC Filings",
      body: "Statutory disclosures filed with the U.S. Securities and Exchange Commission.",
      to: "/sec-filings",
    },
    {
      key: "legacy",
      title: "Legacy Assets",
      body: "Biotechnology intellectual property and prior therapeutic research programs.",
      to: "/legacy-assets",
    },
  ],
};

export const ABOUT = {
  eyebrow: "About Trafalgar International, Inc.",
  headline: "A public-company platform built around financial expertise and strategic growth.",
  headlineAccent: "strategic growth.",
  lead:
    "Trafalgar International, Inc. is a publicly traded acquisition and business development company focused on acquiring, developing and growing businesses in the financial services, technology and intellectual property sectors.",
  supporting:
    "The Company combines experienced leadership, disciplined capital allocation and a flexible transaction platform to pursue opportunities where strategic resources and operational expertise can support sustainable long-term enterprise value.",
  focusTags: [
    "Financial Services",
    "Strategic Acquisitions",
    "Financial Technology",
    "Digital Infrastructure",
    "Intellectual Property",
    "Capital Allocation",
  ],
  whoWeAre: {
    eyebrow: "Who We Are",
    title: "Experienced leadership. Flexible capital. A disciplined approach to growth.",
    body: [
      "Trafalgar International, Inc. is building a platform focused on businesses and technologies with meaningful long-term growth potential, particularly within financial services and technology-enabled markets.",
      "The Company evaluates opportunities based on management quality, market position, scalability, technology, regulatory environment, capital requirements and the potential to create durable enterprise value.",
      "Trafalgar seeks to combine financial and operating experience, strategic capital, public-company access and active execution to help promising businesses expand their capabilities and reach.",
    ],
  },
  platform: [
    {
      num: "01 — IDENTIFY",
      title: "Find businesses with durable potential",
      body:
        "Evaluate financial services, technology and related opportunities where strong fundamentals, capable leadership and attractive market dynamics can support long-term growth.",
    },
    {
      num: "02 — ACQUIRE",
      title: "Structure transactions with discipline",
      body:
        "Pursue acquisitions, strategic investments and partnerships using structures aligned with the economics, risk profile and long-term objectives of each opportunity.",
    },
    {
      num: "03 — BUILD",
      title: "Support scalable enterprise value",
      body:
        "Apply capital, management experience, technology and strategic relationships to help portfolio businesses strengthen operations, expand markets and pursue sustainable growth.",
    },
  ],
  principles: [
    { title: "Disciplined Selection", body: "Evaluate opportunities based on strategic fit, economics, leadership, scalability, risk and long-term value." },
    { title: "Experienced Leadership", body: "Apply financial, transaction and operating experience to strategy, execution and business development." },
    { title: "Flexible Structures", body: "Consider acquisitions, strategic investments, partnerships and other structures appropriate to each opportunity." },
    { title: "Capital Discipline", body: "Deploy capital thoughtfully across acquisitions, operating growth, technology and strategic initiatives." },
  ],
  focus: [
    "Banking and financial services",
    "Financial technology and digital platforms",
    "Strategic acquisitions and investments",
    "Technology-enabled operating businesses",
    "Commercially relevant intellectual property",
    "Long-term capital and operational development",
  ],
  leadership: [
    {
      role: "Chairman of the Board",
      name: "Porfirio Sanchez Talavera",
      body:
        "Mr. Sanchez Talavera brings experience in acquisitions, regulated financial services, telecommunications infrastructure, restructuring and special situations.",
    },
    {
      role: "Chief Executive Officer",
      name: "Carlos Septién",
      body:
        "Mr. Septién provides executive leadership as Trafalgar advances its financial services, technology and strategic acquisition platform.",
    },
  ],
};

export const INVESTORS = {
  eyebrow: "Investor Relations",
  headline: "Investor information for Trafalgar International, Inc.",
  lead:
    "Trafalgar International, Inc. is a publicly traded acquisition and business development company focused on acquiring, developing and growing businesses in the financial services, technology and intellectual property sectors.",
  sub:
    "This Investor Center provides direct access to market information, SEC filings, Company announcements and other resources for shareholders and prospective investors.",
  companyAtAGlance: [
    { label: "Trading Symbol", value: "GCAN" },
    { label: "Market", value: "OTCQB" },
    { label: "CIK", value: "0001695473" },
    { label: "Fiscal Year End", value: "December 31" },
  ],
  transferAgent: {
    name: "ClearTrust, LLC",
    address: "16540 Pointe Village Drive, Suite 210, Lutz, Florida 33558",
    phone: "(813) 235-4490",
  },
  pressReleasesUrl: "https://www.otcmarkets.com/stock/GCAN/news",
  tradingViewUrl: "https://www.tradingview.com/symbols/OTC-GCAN/",
  faqs: [
    { q: "What is Trafalgar International, Inc.'s trading symbol?", a: "The Company's Common Stock currently trades on OTCQB under the symbol GCAN." },
    { q: "When does the Company's fiscal year end?", a: "December 31." },
    { q: "What is Trafalgar International, Inc.'s CIK number?", a: "0001695473." },
    {
      q: "Who is the Company's transfer agent?",
      a: "ClearTrust, LLC, 16540 Pointe Village Drive, Suite 210, Lutz, Florida 33558. Telephone: (813) 235-4490.",
    },
    { q: "Where can I find the Company's SEC filings?", a: "Current filings are available in the SEC Filings section and directly through the SEC's EDGAR database." },
  ],
};

export const CONTACT = {
  eyebrow: "Contact Trafalgar International",
  headline: "Connect with Trafalgar International.",
  lead:
    "Trafalgar International, Inc. welcomes inquiries regarding financial services opportunities, strategic acquisitions, technology, investor relations, partnerships and other matters aligned with the Company's long-term growth strategy.",
  areas: [
    { title: "Financial Services", body: "Opportunities involving banking, lending, financial platforms and related financial services businesses." },
    { title: "Acquisitions", body: "Businesses, assets, strategic investments and special situations that may fit Trafalgar's growth strategy." },
    { title: "Investor Relations", body: "Questions regarding public filings, Company strategy, market information and investor resources." },
    { title: "Corporate Inquiries", body: "Media, strategic introductions, partnerships and other general Company inquiries." },
  ],
  interests: [
    "Banking and financial services businesses",
    "Financial technology and digital platforms",
    "Acquisitions and strategic investments",
    "Technology-enabled operating businesses",
    "Commercially relevant intellectual property",
    "Joint ventures and strategic partnerships",
  ],
  disclaimer:
    "Submission of information does not create a confidential, fiduciary, advisory or contractual relationship with Trafalgar International, Inc. Please do not submit confidential or proprietary information unless requested by an authorized Company representative.",
  inquiryTypes: [
    "Financial Services Opportunity",
    "Acquisition Opportunity",
    "Technology Opportunity",
    "Strategic Partnership",
    "Investor Relations",
    "Media Inquiry",
    "General Inquiry",
  ],
};

// Legacy Assets — biotech / cannabis research content, preserved verbatim from the-science.html.
export const LEGACY = {
  eyebrow: "Legacy Assets",
  headline: "Biotechnology intellectual property & prior therapeutic research",
  headlineAccent: "therapeutic research",
  lead:
    "Trafalgar International, Inc.'s historical operations, conducted under the former name Greater Cannabis Company, Inc., produced biotechnology intellectual property, therapeutic development assets, scientific relationships, and research initiatives that remain part of the Company's business foundation. The Company intends to continue evaluating appropriate pathways for those assets, including internal development, licensing, strategic collaboration, joint ventures, and other commercial arrangements.",
  combinedApproach: {
    title: "GCANRx's Combined Therapeutic Approach to Treating ASD",
  },
  groundbreaking: {
    title: "Groundbreaking ASD Research",
    body:
      "In 2017, Dr. Adi Aran conducted the world's most comprehensive study on the effects of CBD oil on children with autism. It was also the first double-blind placebo-controlled trial of its kind. The results of the study were encouraging, with 49% of one group reporting an improvement in disruptive behavior. But it was also clear that there was a need for follow up research.",
  },
  followUp: {
    title: "Compelling Follow Up Study",
    body:
      "In 2019, a second study focused on children diagnosed with ASD, which was also characterized by severe behavior disturbance. The results of this study also showed a positive correlation between CBD and reduced symptoms:",
    stats: [
      { pct: "61%", label: "Reported much improved or very much improved behavioral outbursts" },
      { pct: "41%", label: "Showed improvement of communication problems" },
      { pct: "39%", label: "Reported reduced anxiety" },
      { pct: "29%", label: "Improvement in disruptive behaviors" },
      { pct: "33%", label: "Parents reported less stress on average" },
    ],
  },
  combined: {
    title: "Greater Results With Combined Treatment",
    body:
      "In addition to CBD, proprietary compounds have demonstrated particular efficacy for treating ASD associated symptoms in preliminary trials. Each of these compounds on their own demonstrated limited efficacy, which is attributed to the highly complex nature of ASD. A combined treatment with these compounds can lead to a significantly greater reduction of disruptive behavior and core autistic symptoms while limiting side effects.",
  },
  phase2: {
    title: "Phase II Clinical Trial",
    body:
      "GCANRx has teamed up with a world renowned research center to treat 100 children diagnosed with ASD and related behavioral problems, with a combination of CBD, and additional proprietary compounds for up to 24 weeks.",
    advantages: [
      { title: "First Study of its Kind", body: "combining proven CBD with empirically supported therapeutic compounds" },
      { title: "Substantiated by Pre-Clinical Trial", body: "as well as anecdotal and predecessor clinical results" },
      { title: "Conducted by Leading Researcher", body: "in the field with a proven track record of results" },
      { title: "Combination of Compounds", body: "ensures the uniqueness of the study and patentability of its results" },
    ],
  },
  pathways: [
    "Licensing",
    "Strategic Partnerships",
    "Joint Ventures",
    "Commercialization",
    "Technology Acquisitions",
    "Portfolio Development",
  ],
};

// Regulatory disclaimer preserved verbatim from source (footer + relevant pages).
export const DISCLAIMER = {
  forwardLooking:
    "Forward-Looking Statements: This website contains forward-looking statements within the meaning of Section 27A of the Securities Act of 1933 and Section 21E of the Securities Exchange Act of 1934. All statements other than statements of historical fact are forward-looking statements subject to risk and uncertainty. Past performance is no guarantee of future financial results.",
  rebrandNotice:
    "Trafalgar International, Inc. (OTCQB: GCAN), SEC CIK 0001695473, was formerly known as Greater Cannabis Company, Inc. and rebranded on July 29, 2026 as the U.S. expansion vehicle of Mexican financial group Empresas Trafalgar.",
  edgarNote:
    "Official SEC disclosures are available via the SEC EDGAR database at https://www.sec.gov/edgar/browse/?CIK=0001695473.",
};
